// extracted by mini-css-extract-plugin
export default {"container":"oC4DNUTtXt7UIx4Ny_Ay","header":"Lzxcef7paz7xD3TfrLNO","subtitle":"d3546YHBVrcNxcQGCo7c"};